import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	input,
	OnInit,
} from '@angular/core';
import { map, Observable } from 'rxjs';
import { UniversityUtils } from '../../utils/university.utils';
import {
	UniversitySections,
	Product,
	UniversitySection,
	ImageAndText,
} from '@uc/web/shared/data-models';
import { UniversityApiService } from '../../data-access/services/university-api.service';
import { AsyncPipe } from '@angular/common';
import { UniversitySectionComponent } from '../university-section/university-section.component';

@Component({
	selector: 'uc-university-sections',
	templateUrl: './university-sections.component.html',
	imports: [AsyncPipe, UniversitySectionComponent],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UniversitySectionsComponent implements OnInit {
	product = input<Product>('undergraduate');
	universityUrl = input<string>('');
	uniId = input<number | null>(null);
	uniName = input<string>('');
	/**
	 * UG/PG university external url
	 */
	externalUrl = input<string>();
	ugSearchOrderPosition = input<number | null>(null);

	universitySections$!: Observable<UniversitySections>;
	universityInformation!: UniversitySection;
	campusLife!: UniversitySection;
	tuitionFees!: UniversitySection;
	universityUtils = new UniversityUtils();

	constructor(
		private _universityApiSrv: UniversityApiService,
		private _cd: ChangeDetectorRef,
	) {}

	ngOnInit(): void {
		this.universitySections$ = this._universityApiSrv
			.getUniversitySections({
				universityUrl: this.universityUrl(),
				product: this.product(),
			})
			.pipe(
				map((universitySections) => {
					const [universityInformation, campusLife, tuitionFees] =
						this.universityUtils.selectUniversitySectionData(
							universitySections,
						);
					this.universityInformation =
						universityInformation as UniversitySection;
					this.campusLife = campusLife as UniversitySection;
					this.tuitionFees = tuitionFees as UniversitySection;
					this._cd.detectChanges();
					return universitySections;
				}),
			);
	}

	// Check if UniversitySection has empty values
	isObjectEmpty(obj: UniversitySection | null | undefined) {
		if (obj === null || obj === undefined) {
			return true;
		}
		return Object.values(obj).every(this.isEmptyValue);
	}

	private isEmptyValue = (value: ImageAndText | string | null): boolean => {
		if (value === null || value === '') return true;
		if (typeof value === 'object') {
			return Object.values(value).every(this.isEmptyValue);
		}
		return false;
	};
}
